// eslint-disable-next-line no-restricted-imports
import { useTheme as useThemeEmotion } from '@emotion/react';
import { type Theme } from './theme.model';

export const useTheme: () => Theme = useThemeEmotion as any;
